import { call, put, takeLatest } from 'redux-saga/effects';
import { Creators, Types } from '../../redux/user/actions';
import {
  saveUser as saveUserApi,
  fetchUser as fetchUserApi,
  updateUser as updateUserApi
} from '../../api/user';

export function* saveUser(actions) {
  try {
    const { payload } = actions;
    const response = yield call(saveUserApi, payload);
    const { data } = response
    if (data && data.status === "200")
      yield put(Creators.saveUserSuccess(data && data.request_id));
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.saveUserFailure(error_message));
  }
}

export function* fetchUser(actions) {
  try {
    const response = yield call(fetchUserApi, { customer_id: actions.user_id });
    let user_data = response.data;
    user_data.confirm_email = user_data.email;
    yield put(Creators.fetchUserSuccess(user_data));
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.fetchUserFailure(error_message));
  }
}

export function* updateUser(actions) {
  try {
    const { history, payload } = actions;
    const data = yield call(updateUserApi, payload);
    yield put(Creators.updateUserSuccess(data));
    history.push('/activate/step/three');
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.updateUserFailure(error_message));
  }
}

export function* watchSaveUser() {
  yield takeLatest(Types.SAVE_USER, saveUser);
}

export function* watchFetchUser() {
  yield takeLatest(Types.FETCH_USER, fetchUser);
}

export function* watchUpdateUser() {
  yield takeLatest(Types.UPDATE_USER, updateUser);
}

